<template>
  <div>
    <div v-if="is_mobile">
      <asta-mobile></asta-mobile>
    </div>
    <div v-else>
      <asta-desktop></asta-desktop>
    </div>

    <!-- brain -->
    <brain v-if="admin"></brain>

    <!--Dialogs -->
    <!-- seleziona chi sceglie (chooser) -->
    <asta-chooser :selected="selectedChooser" v-if="admin"></asta-chooser>
    <!-- calciatore da mettere all'asta (manuale o random) -->
    <asta-auctioneer-random v-if="mode_random"></asta-auctioneer-random>
    <asta-auctioneer v-else></asta-auctioneer>
    <!-- dialog a seconda delle modalità -->
    <asta-assegna v-if="mode_assegna"></asta-assegna>
    <asta-selvaggia v-if="mode_selvaggia"></asta-selvaggia>
    <asta-busta-chiusa v-if="mode_bustachiusa"></asta-busta-chiusa>
    <asta-poker v-if="mode_poker"></asta-poker>
    <!-- altre -->
    <!-- <add-squadra></add-squadra> -->
    <asta-sblocco></asta-sblocco>
    <asta-come-funziona></asta-come-funziona>
    <asta-impostazioni></asta-impostazioni>
    <asta-numpad></asta-numpad>
    <asta-logs></asta-logs>
    <asta-order></asta-order>
    <dialog-scartati></dialog-scartati>
    <dialog-scarta-calciatori></dialog-scarta-calciatori>
    <valore-edit></valore-edit>
    <asta-change-admin></asta-change-admin>
    <asta-edit-squadra v-if="Config.STANDALONE"></asta-edit-squadra>
    <asta-ruoli-custom v-if="Config.STANDALONE"></asta-ruoli-custom>
    <allinea-rose v-if="!Config.STANDALONE"></allinea-rose>

    <!-- swals -->
    <swal-import-rose v-if="!Config.STANDALONE"></swal-import-rose>
    <swal-save-rose v-if="!Config.STANDALONE"></swal-save-rose>
    <swal-download-rose></swal-download-rose>
    <swal-asta-in-corso></swal-asta-in-corso>
    <swal-admin></swal-admin>
    <swal-admin-escluso></swal-admin-escluso>
  </div>
</template>

<script>
import db from "../js/db";
import Vuex from "vuex";
import AstaNav from "./AstaNav.vue";
import AstaMobile from "./layout/AstaMobile";
import AstaDesktop from "./layout/AstaDesktop";
import AstaAuctioneer from "./dialogs/AstaAuctioneer";
import AstaPoker from "./dialogs/AstaPoker";
import AstaNumpad from "./dialogs/AstaNumpad";
import AstaComeFunziona from "./dialogs/AstaComeFunziona";
import AstaImpostazioni from "./dialogs/AstaImpostazioni";
import AstaSblocco from "./dialogs/AstaSblocco";
import AstaChooser from "./dialogs/AstaChooser";
import AstaAuctioneerRandom from "./dialogs/AstaAuctioneerRandom";
import AstaSelvaggia from "./dialogs/AstaSelvaggia";
import AstaBustaChiusa from "./dialogs/AstaBustaChiusa";
import AstaLogs from "./dialogs/AstaLogs";
import AstaOrder from "./dialogs/AstaOrder";
import DialogScartati from "./dialogs/DialogScartati";
import DialogScartaCalciatori from "./dialogs/DialogScartaCalciatori";
import AstaEditSquadra from "./dialogs/AstaEditSquadra";
import ValoreEdit from "./common/ValoreEdit";
import Brain from "./Brain";
import AstaAssegna from "./dialogs/AstaAssegna";
import AllineaRose from "./dialogs/AllineaRose";
import AstaRuoliCustom from "./dialogs/AstaRuoliCustom";
import AstaChangeAdmin from "./dialogs/AstaChangeAdmin";
import SwalImportRose from "./swal/SwalImportRose";
import SwalSaveRose from "./swal/SwalSaveRose";
import SwalDownloadRose from "./swal/SwalDownloadRose";
import SwalAstaInCorso from "./swal/SwalAstaInCorso";
import SwalAdmin from "./swal/SwalAdmin";
import SwalAdminEscluso from "./swal/SwalAdminEscluso";
import mixins from "../js/mixins";
import toast from "../js/toast";
import * as Helpers from "../js/helpers";
import Constants from "../js/constants";
import Config from "../../config-app/config";

export default {
  name: "asta",
  mixins: [mixins, toast],
  components: {
    AstaNav,
    AstaAuctioneer,
    AstaPoker,
    AstaMobile,
    AstaDesktop,
    AstaNumpad,
    AstaLogs,
    AstaOrder,
    DialogScartati,
    DialogScartaCalciatori,
    AstaImpostazioni,
    AstaSblocco,
    AstaChooser,
    AstaAuctioneerRandom,
    AstaSelvaggia,
    AstaBustaChiusa,
    ValoreEdit,
    AstaEditSquadra,
    AllineaRose,
    AstaRuoliCustom,
    AstaChangeAdmin,
    Brain,
    AstaAssegna,
    AstaComeFunziona,
    SwalImportRose,
    SwalSaveRose,
    SwalDownloadRose,
    SwalAstaInCorso,
    SwalAdmin,
    SwalAdminEscluso,
  },
  data() {
    return {
      showImpostazioni: false,
    };
  },

  mounted() {
    console.log("--> Asta mounted.");
    // db.on("presenceOnHide", this.redirectToReset);
    db.on("calciatoreInAsta", this.playAudio);
    // db.on("asta_msg", this.showAstaMsg);
    db.on("status", this.handleStatus);
    db.on("counter", this.checkPremium);
    db.on("fetchedOnline", this.redirectIfReset);
    this.fetchAllAsta();
    this.checkPremium();

    // if (this.admin) {
    this.checkAllineamentoRose();
    // }

    if (window.firebase) {
      this.showImpostazioni = window.firebase.showImpostazioni;
    } else if (this.$route.query.showImpostazioni == "true") {
      this.showImpostazioni = true;
    }

    if (this.showImpostazioni) {
      db.emit("showImpostazioni");
    }

    const showInvito = !!this.$route.query.showInvito;
    if (showInvito) {
      db.emit("invitoEmitted");
    }
  },

  destroyed() {
    console.log("<-- Asta destroyed.");
    this.clearAsta();
  },
  methods: {
    fetchAllAsta() {
      // "fetch" => lo stato si mette in ascolto su Firebase
      //            per auto-aggiornarsi quando cambia qualcosa su Firebase
      let p2 = this.$store.dispatch("fetchAstaInfo");
      let p3 = this.$store.dispatch("fetchCalciatoriCustom");
      let p4 = this.$store.dispatch("fetchSquadre");
      let p5 = this.$store.dispatch("fetchOnline");
      let p6 = this.$store.dispatch("fetchMessages");
      let p7 = this.$store.dispatch("fetchScartati");
      let p8 = this.$store.dispatch("fetchRound");
      let p9 = this.$store.dispatch("fetchAstaLogsLast");
      let p10 = this.$store.dispatch("fetchMyPlan");
      return Promise.all([p2, p3, p4, p5, p6, p7, p8, p9, p10]);
    },
    clearAsta() {
      // listeners
      db.removeAllListeners();
      // store
      // non posso farlo perchè Main.vue ha bisogno di store.asta_info
      // che viene riempito solo .once al Main.mounted
      // this.$store.dispatch("clearAsta");
    },
    redirectIfReset() {
      if (
        this.asta_online &&
        this.asta_online[this.user_uid] === Constants.PRESENCE_STATES.RESET
      ) {
        this.warnBeforeUnload = false;
        this.$router.push({
          path: "/reset",
          query: { asta_id: this.asta_id, type: "sessionExists" },
        });
        // window.location.replace(Config.HOST);
      }
    },
    // redirectToReset() {
    //   this.warnBeforeUnload = false;
    //   this.$router.push({ path: "/reset", query: { asta_id: this.asta_id,  type: "presenceOnHide"} });
    // },
    handleStatus(status) {
      this.handleSpeaker(status);
      if (status == Constants.ASTA_STATUS.NOT_RUNNING) {
        db.emit("numpad", false);
      }
    },
    handleSpeaker(status) {
      switch (status) {
        case Constants.ASTA_STATUS.NOT_RUNNING:
          db.emit("dismissSpeaker");
          break;
        case Constants.ASTA_STATUS.RUNNING:
          if (
            this.asta_round.speaker == this.user_uid &&
            this.migliore_offerta.vincitore != this.user_uid
          ) {
            db.emit("showSpeaker");
          } else {
            db.emit("dismissSpeaker");
          }
      }
    },

    // showAstaMsg(msg) {
    //   var title,
    //     type = "";
    //   switch (msg.type) {
    //     case Constants.ASTA_MSG.ASSEGNA:
    //       title = "";
    //       type = "info";
    //       break;
    //     case Constants.ASTA_MSG.ANNULLA:
    //       title = "";
    //       type = "warning";
    //       break;
    //   }
    //   this.infoToast(title, msg.text, type);
    // },
    playAudio() {
      if (this.asta_round.calciatoreInAsta !== null && this.useSound == 1) {
        var audio = new Audio(
          "https://fpz.s3-eu-west-1.amazonaws.com/files/public/audio/UI_NOTIFICATION_Bell_07.wav"
        ); // path to file
        audio.play();
      }
    },
    checkPremium() {
      let counter = this.asta_info.counter;
      if (counter <= 0 && !this.premium) {
        Swal.fire({
          title: "AstaLive",
          icon: "info",
          text: "Hai terminato gli acquisti della versione di prova",
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: "Sblocca",
          cancelButtonText: "Chiudi",
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed == true) {
            db.emit("showSblocco");
          }
        });
      }
    },
    selectTab: function (idx) {
      this.$store.dispatch("selectTab", idx);
    },
    selectedChooser(id) {
      db.resetRound(id)
        .then(() => {
          db.setSetting("status", Constants.ASTA_STATUS.RUNNING);
        })
        .catch(() => {
          this.errorToast("Errore", "Operazione non consentita!");
        });
    },
  },
  computed: {
    ...Vuex.mapGetters(["migliore_offerta", "useSound", "asta_online"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.asta {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

// .asta .layout {
//   margin-left: 0px !important;
//   margin-right: 0px !important;
// }
</style>
